const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function apiRequest(endpoint, method, body, options = {}) {
  const { retries = 1, retryDelay = 1000 } = options;

  let headers = {
    "Content-Type": "application/json",
  };

  let requestOptions = {
    method,
    headers,
  };

  if (body instanceof FormData) {
    delete requestOptions.headers["Content-Type"];
    requestOptions.body = body;
  } else if (body) {
    requestOptions.body = JSON.stringify(body);
  }

  if (options.credentials === "include") {
    requestOptions = {
      ...requestOptions,
      credentials: "include",
    };
  }

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api${endpoint}`,
        requestOptions
      );

      if (response.ok) {
        return await response.json();
      }

      const errorData = await response.json().catch(() => ({}));
      console.error(
        `API Error (Attempt ${attempt}/${retries}): ${errorData.error || response.statusText}`
      );

      if (attempt < retries) {
        await new Promise((res) => setTimeout(res, retryDelay));
      }
    } catch (error) {
      console.error(
        `API Request Failed (Attempt ${attempt}/${retries}):`,
        error
      );
      if (attempt < retries) {
        await new Promise((res) => setTimeout(res, retryDelay));
      }
    }
  }

  return null;
}
